import * as yup from "yup";

const discordTagValidation = yup
  .string()
  .transform((value) => (value === "" ? undefined : value)) // Handle empty strings
  .nullable()
  .notRequired()
  .lowercase()
  .min(2, "Username must be at least 2 characters long")
  .max(32, "Username must be at most 32 characters long")
  .matches(/^(?!.*\.\.)(?!.*__)[a-z0-9._]+$/, {
    message:
      "Username can only contain lowercase letters, numbers, underscores, and periods, and cannot have consecutive periods or underscores.",
  })
  .matches(/^(?![0-9._]*$)[a-z0-9._]+$/, {
    message: "Username must contain at least one letter.",
  })
  .matches(/^(?!.*\b(Discord|discord|discordstaff|systemmessages)\b)[a-z0-9._]+$/, {
    message: "Username cannot impersonate Discord or its staff.",
  });

export const createNewUserValidation = yup.object().shape({
  firstName: yup
    .string()
    .required("First Name Is Required")
    .min(2, "First Name must be at least 2 characters")
    .max(50),
  lastName: yup
    .string()
    .required("Last Name Is Required")
    .min(2, "Last Name must be at least 2 characters")
    .max(50),
  email: yup
    .string()
    .email("Email must be a valid email")
    .required("Email Is Required"),
  screenName: yup
    .string()
    .required("Screen Name Is Required")
    .min(3, "Screen Name must be at least 3 characters")
    .max(50),
  password: yup
    .string()
    .required("Password Is Required")
    .min(6, "Password must be at least 6 characters")
    .max(50),
  confirmPassword: yup
    .string()
    .required("Confirm Password Is Required")
    .oneOf([yup.ref("password"), null], "Passwords must match"),
  address1: yup
    .string()
    .required("Address 1 Is Required")
    .min(4, "Address must be at least 4 characters")
    .max(50),
  address2: yup
    .string()
    .transform((value) => (value === "" ? undefined : value)) // Handle empty strings
    .notRequired()
    .min(4, "Address must be at least 4 characters")
    .max(50),
  state: yup
    .string()
    .required("State Is Required")
    .min(2, "State must be at least 2 characters")
    .max(50),
  city: yup
    .string()
    .required("City Is Required")
    .min(2, "City must be at least 2 characters")
    .max(50),
  zip: yup
    .string()
    .required("ZIP Is Required")
    .min(3, "ZIP must be at least 3 characters")
    .max(20),
  mobilePhone: yup
    .string()
    .required("Mobile Phone Is Required")
    .matches(/^\+?\d{7,15}$/, "Mobile Phone must be a valid phone number"),
  paypalEmail: yup
    .string()
    .email("PayPal Email must be a valid email")
    .notRequired(),
  discordTag: discordTagValidation,
});
